import Box from '@mui/material/Box'
import LinearProgress from '@mui/material/LinearProgress'

// What a page shows while it reads a new window or refreshes: the last answer
// stays on screen, faded and inert, under a bar running along its top, so the
// layout does not jump and nobody reads the old window's numbers as the new
// one's. A first read has no last answer, and fades its empty shape the same.
const Refreshing = ({ active, children }) => (
  <Box sx={{ position: 'relative' }} aria-busy={active}>
    {active && (
      <LinearProgress
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1,
          height: 3,
          borderRadius: 2,
        }}
      />
    )}
    <Box
      sx={{
        opacity: active ? 0.4 : 1,
        pointerEvents: active ? 'none' : 'auto',
        transition: 'opacity 150ms',
      }}
    >
      {children}
    </Box>
  </Box>
)

export default Refreshing
